/**
 * Geometria do launcher do widget da Callbell (aside fixo no canto inferior
 * direito, a 1,25rem das bordas; 3rem até 768px de largura e 4rem acima). O
 * ChatLauncher copia essa geometria para o botão não pular quando o widget
 * substitui o nosso.
 */
export const WEBCHAT_LAUNCHER_LAYOUT = {
  offset: '1.25rem',
  size: '3rem',
  tabletSize: '4rem',
  tabletBreakpoint: '768px',
};

const CLEARANCE_GAP = '0.75rem';

/**
 * Distância da borda (inferior ou direita) que um elemento fixo no canto
 * inferior direito precisa manter para não ficar embaixo do launcher.
 */
export const WEBCHAT_LAUNCHER_CLEARANCE = {
  mobile: `calc(${WEBCHAT_LAUNCHER_LAYOUT.offset} + ${WEBCHAT_LAUNCHER_LAYOUT.size} + ${CLEARANCE_GAP})`,
  tablet: `calc(${WEBCHAT_LAUNCHER_LAYOUT.offset} + ${WEBCHAT_LAUNCHER_LAYOUT.tabletSize} + ${CLEARANCE_GAP})`,
};
